import { Route, Routes, useParams } from "react-router-dom";
import HampiOneDayPackage from "../components/pages/hampi-tour-package";
import HampiHalfDayPackage from "../components/pages/hampi-half-day-package";

const PackageScreen = () => {
  const { hampi } = useParams();
  console.log("URL Param:", hampi); // Debugging

  return (
    <>
      {hampi === "hampi-tour-package" && <HampiOneDayPackage />}
      {hampi === "hampi-half-day" && <HampiHalfDayPackage />}
      {/* Add more conditions if needed */}
    </>
  );
};
 export default PackageScreen
